import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldTimeOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldTimeOutlined";
import AntdIcon from '../components/AntdIcon';
var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FieldTimeOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FieldTimeOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FieldTimeOutlined';
}
export default RefIcon;